import React, { useState, useEffect } from 'react';
import { formMasterAPI, commonAPI } from '../../services/api';
import toast from 'react-hot-toast';
import ChartComponent from '../../components/common/ChartComponent';
import { format } from 'date-fns';

const ClassReports = () => {
  const [myClasses, setMyClasses] = useState([]);
  const [academicSessions, setAcademicSessions] = useState([]);
  const [terms, setTerms] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSession, setSelectedSession] = useState('');
  const [selectedTerm, setSelectedTerm] = useState('');
  const [performanceData, setPerformanceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState('summary');
  const [generatingReport, setGeneratingReport] = useState(false);
  const [SubjectChartData, setSubjectChartData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [reportTemplates, setreportTemplates] = useState([]);
  const [GradeDistributionData, setGradeDistributionData] = useState([]);
  const [PerformanceTrendData, setPerformanceTrendData] = useState([]);

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      fetchTerms(selectedSession);
    }
  }, [selectedSession]);

  useEffect(() => {
    if (selectedClass && selectedSession && selectedTerm) {
      fetchPerformanceData();
    }
  }, [selectedClass, selectedSession, selectedTerm]);

  const fetchInitialData = async () => {
    try {
      setLoading(true);
      const [classesRes, sessionsRes] = await Promise.all([
        formMasterAPI.getMyClasses(),
        formMasterAPI.getAcademicSessions(),
        // commonAPI.getAcademicSessions(),
      ]);

      setMyClasses(classesRes.data);
      setAcademicSessions(sessionsRes.data);

      // Set defaults
      if (classesRes.data.length > 0) {
        setSelectedClass(classesRes.data[0].class_id);
      }
      if (sessionsRes.data.length > 0) {
        setSelectedSession(sessionsRes.data[0].id);
      }

    } catch (error) {
      toast.error('Failed to load initial data');
    } finally {
      setLoading(false);
    }
  };

  const fetchTerms = async (sessionId) => {
    try {
      const response = await commonAPI.getTerms(sessionId);
      setTerms(response.data);
      if (response.data.length > 0) {
        setSelectedTerm(response.data[0].id);
      }
    } catch (error) {
      toast.error('Failed to load terms');
    }
  };

  // const fetchPerformanceData = async () => {
  //   try {
  //     setLoading(true);
  //     const params = {
  //       academic_session_id: selectedSession,
  //       term_id: selectedTerm,
  //       class_id: selectedClass,
  //     };

  //     const response = await formMasterAPI.getClassPerformance(params);
  //     setPerformanceData(response.data);
  //   } catch (error) {
  //     toast.error('Failed to load performance data');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // Update the fetchPerformanceData function
const fetchPerformanceData = async () => {
  try {
    setLoading(true);
    const params = {
      academic_session_id: selectedSession,
      term_id: selectedTerm,
      class_id: selectedClass,
      detailed: true  // Request detailed data for reports
    };

    const response = await formMasterAPI.getClassPerformance(params);
    setPerformanceData(response.data);
    
    // Generate charts with real data
    generateCharts(response.data);
    
  } catch (error) {
    toast.error('Failed to load performance data');
  } finally {
    setLoading(false);
  }
};

// Update chart generation functions to use real data
const generateCharts = (data) => {
  // Subject Performance Chart
  if (data.subject_chart_data && data.subject_chart_data.length > 0) {
    const subjectChartData = {
      labels: data.subject_chart_data.map(subj => subj.subject_name),
      datasets: [
        {
          label: 'Average Score',
          data: data.subject_chart_data.map(subj => subj.average_score),
          backgroundColor: '#3b82f6',
          borderColor: '#2563eb',
          borderWidth: 2,
        }
      ]
    };
    setSubjectChartData(subjectChartData);
  }
  
  // Grade Distribution Chart
  if (data.grade_distribution) {
    const gradeChartData = {
      labels: Object.keys(data.grade_distribution),
      datasets: [{
        data: Object.values(data.grade_distribution),
        backgroundColor: [
          '#10b981', // A+
          '#34d399', // A
          '#60a5fa', // B
          '#fbbf24', // C
          '#f97316', // D
          '#ef4444', // F
        ],
      }]
    };
    setGradeDistributionData(gradeChartData);
  }
  
  // Performance Trend Chart (if available)
  if (data.performance_trend && data.performance_trend.length > 0) {
    const trendChartData = {
      labels: data.performance_trend.map(t => t.term_name),
      datasets: [
        {
          label: 'Class Average',
          data: data.performance_trend.map(t => t.average_score),
          borderColor: '#3b82f6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          tension: 0.3,
          fill: true,
        }
      ]
    };
    setPerformanceTrendData(trendChartData);
  }
};



  const getCurrentClass = () => {
    return myClasses.find(cls => cls.class_id == selectedClass);
  };

  const getCurrentSession = () => {
    return academicSessions.find(session => session.id == selectedSession);
  };

  const getCurrentTerm = () => {
    return terms.find(term => term.id == selectedTerm);
  };










// Update the handleGenerateReport function to download directly
// const handleGenerateReport = async (format) => {
//   try {
//     setGeneratingReport(true);
    
//     // First, get detailed performance data
//     const params = {
//       academic_session_id: selectedSession,
//       term_id: selectedTerm,
//       class_id: selectedClass,
//       detailed: true
//     };
    
//     const response = await formMasterAPI.getClassPerformance(params);
    
//     // Now generate the report with the detailed data
//     const reportData = {
//       class_id: selectedClass,
//       academic_session_id: selectedSession,
//       term_id: selectedTerm,
//       report_type: format, // 'pdf' or 'excel'
//       performance_data: response.data
//     };
    
//     // Call the report generation endpoint
//     const reportResponse = await formMasterAPI.generateClassReport(reportData);
    
//     // Extract the download URL from the response
//     const downloadUrl = reportResponse.data.download_url;
    
//     // Download the file directly without redirect
//     if (downloadUrl) {
//       // Create an invisible anchor element
//       const link = document.createElement('a');
//       link.href = downloadUrl;
      
//       // Set the download attribute with a filename
//       const currentClass = getCurrentClass();
//       const currentSession = getCurrentSession();
//       const currentTerm = getCurrentTerm();
      
//       const fileName = `Class_Report_${currentClass?.class_name || selectedClass}_${currentSession?.academic_session || selectedSession}_${currentTerm?.term || selectedTerm}_${new Date().toISOString().split('T')[0]}.${format}`;
      
//       link.download = fileName;
//       link.target = '_self'; // Use _self instead of _blank to avoid new tab
      
//       // Append to body, click, and remove
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       toast.success(`${format.toUpperCase()} report downloaded successfully!`);
//     } else {
//       // Fallback: If no download URL, generate client-side
//       generateClientSidePDF(response.data, format);
//     }
    
//   } catch (error) {
//     console.error('Error generating report:', error);
//     toast.error('Failed to generate report');
//   } finally {
//     setGeneratingReport(false);
//   }
// };


// Update the handleGenerateReport function to generate files entirely on frontend
const handleGenerateReport = async (format) => {
  try {
    setGeneratingReport(true);
    
    // Get detailed performance data
    const params = {
      academic_session_id: selectedSession,
      term_id: selectedTerm,
      class_id: selectedClass,
      detailed: true
    };
    
    const response = await formMasterAPI.getClassPerformance(params);
    const data = response.data;
    
    if (format === 'pdf') {
      await generatePDFReport(data);
    } else if (format === 'excel') {
      await generateExcelReport(data);
    } else {
      toast.error('Unsupported format');
    }
    
  } catch (error) {
    console.error('Error generating report:', error);
    toast.error('Failed to generate report');
  } finally {
    setGeneratingReport(false);
  }
};

// Generate PDF report using jsPDF
const generatePDFReport = async (data) => {
  try {
    // Dynamically import jsPDF and plugins
    const { jsPDF } = await import('jspdf');
    await import('jspdf-autotable');
    
    // Initialize PDF
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    let yPos = 20;
    
    // Add header
    doc.setFontSize(20);
    doc.setTextColor(44, 62, 80);
    doc.text(`CLASS PERFORMANCE REPORT`, pageWidth / 2, yPos, { align: 'center' });
    
    yPos += 10;
    doc.setFontSize(14);
    doc.setTextColor(52, 152, 219);
    doc.text(`${data.class_info.class_name}`, pageWidth / 2, yPos, { align: 'center' });
    
    yPos += 8;
    doc.setFontSize(10);
    doc.setTextColor(127, 140, 141);
    doc.text(`Academic Session: ${data.class_info.academic_session} | Term: ${data.class_info.term} | Generated: ${new Date().toLocaleDateString()}`, pageWidth / 2, yPos, { align: 'center' });
    
    yPos += 15;
    
    // Add Class Statistics
    doc.setFontSize(16);
    doc.setTextColor(44, 62, 80);
    doc.text('CLASS STATISTICS', 20, yPos);
    yPos += 10;
    
    // Statistics table
    const statsTable = [
      ['Total Students', data.statistics.total_students],
      ['Class Average', `${data.statistics.class_average}%`],
      ['Highest Average', `${data.statistics.highest_average}%`],
      ['Lowest Average', `${data.statistics.lowest_average}%`],
      ['Standard Deviation', data.statistics.standard_deviation],
      ['Average Total Score', data.statistics.average_total_score]
    ];
    
    doc.autoTable({
      startY: yPos,
      head: [['Metric', 'Value']],
      body: statsTable,
      theme: 'grid',
      headStyles: { fillColor: [52, 152, 219] },
      styles: { fontSize: 10 },
      margin: { left: 20, right: 20 }
    });
    
    yPos = doc.lastAutoTable.finalY + 15;
    
    // Grade Distribution
    doc.setFontSize(16);
    doc.setTextColor(44, 62, 80);
    doc.text('GRADE DISTRIBUTION', 20, yPos);
    yPos += 10;
    
    const gradeData = [];
    Object.entries(data.grade_distribution).forEach(([grade, count]) => {
      gradeData.push([grade, count, `${((count / data.statistics.total_students) * 100).toFixed(1)}%`]);
    });
    
    doc.autoTable({
      startY: yPos,
      head: [['Grade', 'Count', 'Percentage']],
      body: gradeData,
      theme: 'grid',
      headStyles: { fillColor: [46, 204, 113] },
      styles: { fontSize: 10 },
      margin: { left: 20, right: 20 }
    });
    
    yPos = doc.lastAutoTable.finalY + 15;
    
    // Top Students
    doc.setFontSize(16);
    doc.setTextColor(44, 62, 80);
    doc.text('TOP PERFORMERS', 20, yPos);
    yPos += 10;
    
    const topStudents = data.top_students.slice(0, 5).map((student, index) => [
      index + 1,
      student.student_reg,
      student.full_name,
      `${student.average}%`,
      student.total_score,
      student.grade
    ]);
    
    doc.autoTable({
      startY: yPos,
      head: [['Rank', 'Reg Number', 'Name', 'Average', 'Total Score', 'Grade']],
      body: topStudents,
      theme: 'grid',
      headStyles: { fillColor: [155, 89, 182] },
      styles: { fontSize: 10 },
      margin: { left: 20, right: 20 }
    });
    
    yPos = doc.lastAutoTable.finalY + 15;
    
    // Subject Performance
    if (data.subject_performance) {
      doc.addPage();
      yPos = 20;
      
      doc.setFontSize(16);
      doc.setTextColor(44, 62, 80);
      doc.text('SUBJECT-WISE PERFORMANCE', 20, yPos);
      yPos += 10;
      
      const subjectData = [];
      Object.values(data.subject_performance).forEach(subject => {
        subjectData.push([
          subject.subject_name,
          `${subject.average}%`,
          subject.highest,
          subject.lowest,
          subject.students_count
        ]);
      });
      
      doc.autoTable({
        startY: yPos,
        head: [['Subject', 'Average', 'Highest', 'Lowest', 'Students']],
        body: subjectData,
        theme: 'grid',
        headStyles: { fillColor: [230, 126, 34] },
        styles: { fontSize: 10 },
        margin: { left: 20, right: 20 }
      });
      
      yPos = doc.lastAutoTable.finalY + 15;
    }
    
    // Detailed Student Performance (add another page if needed)
    if (data.all_students && data.all_students.length > 0) {
      doc.addPage();
      yPos = 20;
      
      doc.setFontSize(16);
      doc.setTextColor(44, 62, 80);
      doc.text('DETAILED STUDENT PERFORMANCE', 20, yPos);
      yPos += 10;
      
      const studentData = [];
      data.all_students.forEach(student => {
        studentData.push([
          student.position,
          student.student_reg,
          student.full_name,
          `${student.average}%`,
          student.total_score,
          student.grade
        ]);
      });
      
      doc.autoTable({
        startY: yPos,
        head: [['Position', 'Reg Number', 'Name', 'Average', 'Total Score', 'Grade']],
        body: studentData,
        theme: 'striped',
        headStyles: { fillColor: [231, 76, 60] },
        styles: { fontSize: 9 },
        margin: { left: 20, right: 20 }
      });
    }
    
    // Add footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10);
      doc.text(`Generated by: ${data.class_info.form_master}`, 20, doc.internal.pageSize.getHeight() - 10);
    }
    
    // Save the PDF
    const fileName = `Class_Report_${data.class_info.class_name}_${data.class_info.term}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
    
    toast.success('PDF report generated successfully!');
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    toast.error('Failed to generate PDF report');
  }
};

// Generate Excel report using xlsx
const generateExcelReport = async (data) => {
  try {
    const XLSX = await import('xlsx');
    
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // 1. Summary Sheet
    const summaryData = [
      ['CLASS PERFORMANCE REPORT'],
      [''],
      ['Class:', data.class_info.class_name],
      ['Academic Session:', data.class_info.academic_session],
      ['Term:', data.class_info.term],
      ['Form Master:', data.class_info.form_master],
      ['Report Date:', new Date().toLocaleDateString()],
      [''],
      ['CLASS STATISTICS'],
      ['Total Students:', data.statistics.total_students],
      ['Class Average:', data.statistics.class_average],
      ['Highest Average:', data.statistics.highest_average],
      ['Lowest Average:', data.statistics.lowest_average],
      ['Standard Deviation:', data.statistics.standard_deviation],
      ['Average Total Score:', data.statistics.average_total_score],
      [''],
      ['GRADE DISTRIBUTION'],
    ];
    
    // Add grade distribution
    Object.entries(data.grade_distribution).forEach(([grade, count]) => {
      summaryData.push([`${grade}:`, count, `${((count / data.statistics.total_students) * 100).toFixed(1)}%`]);
    });
    
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    XLSX.utils.book_append_sheet(wb, summarySheet, 'Summary');
    
    // 2. Top Students Sheet
    const topStudentsData = [
      ['Rank', 'Registration Number', 'Full Name', 'Average %', 'Total Score', 'Grade', 'Comment']
    ];
    
    data.top_students.forEach((student, index) => {
      topStudentsData.push([
        index + 1,
        student.student_reg,
        student.full_name,
        student.average,
        student.total_score,
        student.grade,
        student.comment || ''
      ]);
    });
    
    const topStudentsSheet = XLSX.utils.aoa_to_sheet(topStudentsData);
    XLSX.utils.book_append_sheet(wb, topStudentsSheet, 'Top Students');
    
    // 3. Subject Performance Sheet
    const subjectData = [
      ['Subject', 'Subject Code', 'Average %', 'Highest Score', 'Lowest Score', 'Students Count', 'Top Performer', 'Top Score']
    ];
    
    Object.values(data.subject_performance).forEach(subject => {
      subjectData.push([
        subject.subject_name,
        subject.subject_code,
        subject.average,
        subject.highest,
        subject.lowest,
        subject.students_count,
        subject.top_performer?.student_name || 'N/A',
        subject.top_performer?.score || 'N/A'
      ]);
    });
    
    const subjectSheet = XLSX.utils.aoa_to_sheet(subjectData);
    XLSX.utils.book_append_sheet(wb, subjectSheet, 'Subject Performance');
    
    // 4. All Students Detailed Sheet
    const allStudentsData = [
      [
        'Position', 'Reg Number', 'Full Name', 'Total Score', 'Average %', 'Grade', 'Comment',
        'Attendance', 'Punctuality', 'Participation', 'Cooperation', 'Responsibility', 'Initiative'
      ]
    ];
    
    // Add subject columns
    const subjectColumns = [];
    Object.values(data.subject_performance).forEach(subject => {
      subjectColumns.push(subject.subject_name);
    });
    
    allStudentsData[0] = [...allStudentsData[0], ...subjectColumns];
    
    // Add student rows
    data.all_students.forEach(student => {
      const row = [
        student.position,
        student.student_reg,
        student.full_name,
        student.total_score,
        student.average,
        student.grade,
        student.comment || '',
        student.psycho_motor.attendance,
        student.psycho_motor.punctuality,
        student.psycho_motor.participation,
        student.affective.cooperation,
        student.affective.responsibility,
        student.affective.initiative
      ];
      
      // Add subject scores
      Object.values(data.subject_performance).forEach(subject => {
        const subjectId = subject.subject_id || Object.keys(data.subject_performance).find(key => 
          data.subject_performance[key].subject_name === subject.subject_name
        );
        const score = student.subject_scores[subjectId]?.score || 0;
        row.push(score);
      });
      
      allStudentsData.push(row);
    });
    
    const allStudentsSheet = XLSX.utils.aoa_to_sheet(allStudentsData);
    XLSX.utils.book_append_sheet(wb, allStudentsSheet, 'All Students');
    
    // 5. Performance Trend Sheet
    if (data.performance_trend && data.performance_trend.length > 0) {
      const trendData = [
        ['Term', 'Average Score', 'Student Count']
      ];
      
      data.performance_trend.forEach(trend => {
        trendData.push([
          trend.term_name,
          trend.average_score,
          trend.student_count
        ]);
      });
      
      const trendSheet = XLSX.utils.aoa_to_sheet(trendData);
      XLSX.utils.book_append_sheet(wb, trendSheet, 'Performance Trend');
    }
    
    // Generate Excel file
    const fileName = `Class_Report_${data.class_info.class_name}_${data.class_info.term}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    
    toast.success('Excel report generated successfully!');
    
  } catch (error) {
    console.error('Error generating Excel:', error);
    toast.error('Failed to generate Excel report');
  }
};

// Client-side PDF generation (using jsPDF as example)
const generateClientSidePDF = (data, format) => {
  if (format === 'pdf') {
    // Using jsPDF library
    import('jspdf').then((jsPDFModule) => {
      const { jsPDF } = jsPDFModule;
      const doc = new jsPDF();
      
      // Add header
      doc.setFontSize(20);
      doc.text(`Class Performance Report - ${data.class_info.class_name}`, 20, 20);
      
      // Add class info
      doc.setFontSize(12);
      doc.text(`Academic Session: ${data.class_info.academic_session}`, 20, 40);
      doc.text(`Term: ${data.class_info.term}`, 20, 50);
      doc.text(`Form Master: ${data.class_info.form_master}`, 20, 60);
      doc.text(`Report Date: ${new Date().toLocaleDateString()}`, 20, 70);
      
      // Add statistics
      doc.setFontSize(14);
      doc.text('Class Statistics', 20, 90);
      doc.setFontSize(12);
      doc.text(`Total Students: ${data.statistics.total_students}`, 20, 100);
      doc.text(`Class Average: ${data.statistics.class_average}%`, 20, 110);
      doc.text(`Highest Score: ${data.statistics.highest_average}%`, 20, 120);
      doc.text(`Lowest Score: ${data.statistics.lowest_average}%`, 20, 130);
      
      // Add grade distribution
      doc.setFontSize(14);
      doc.text('Grade Distribution', 20, 150);
      doc.setFontSize(12);
      let yPos = 160;
      Object.entries(data.grade_distribution || {}).forEach(([grade, count]) => {
        doc.text(`${grade}: ${count} students`, 20, yPos);
        yPos += 10;
      });
      
      // Save the PDF
      doc.save(`class_report_${data.class_info.class_name}_${data.class_info.term}.pdf`);
    });
  }
};


  const getSubjectPerformanceChartData = () => {
    if (!performanceData?.subject_performance) return null;

    const subjects = Object.keys(performanceData.subject_performance);
    const averages = subjects.map(subject => 
      performanceData.subject_performance[subject].average
    );

    return {
      labels: subjects,
      datasets: [
        {
          label: 'Average Score',
          data: averages,
          backgroundColor: '#3b82f6',
          borderColor: '#2563eb',
          borderWidth: 1,
        }
      ]
    };
  };

  const getGradeDistributionData = () => {
    // Mock grade distribution
    const distribution = {
      'A+': 5,
      'A': 12,
      'B': 18,
      'C': 8,
      'D': 3,
      'F': 2,
    };

    return {
      labels: Object.keys(distribution),
      datasets: [{
        data: Object.values(distribution),
        backgroundColor: [
          '#10b981',
          '#34d399',
          '#60a5fa',
          '#fbbf24',
          '#f97316',
          '#ef4444',
        ],
      }]
    };
  };

  const getPerformanceTrendData = () => {
    // Mock trend data
    const terms = ['Term 1', 'Term 2', 'Term 3'];
    const classScores = [72, 75, 78];
    const schoolAverage = [70, 71, 73];

    return {
      labels: terms,
      datasets: [
        {
          label: 'Class Average',
          data: classScores,
          borderColor: '#3b82f6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          tension: 0.3,
          fill: true,
        },
        {
          label: 'School Average',
          data: schoolAverage,
          borderColor: '#10b981',
          backgroundColor: 'rgba(16, 185, 129, 0.1)',
          borderDash: [5, 5],
          tension: 0.3,
        }
      ]
    };
  };

  if (loading && !performanceData) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Class Reports & Analytics</h1>
          <p className="text-gray-600">Generate comprehensive reports and analyze class performance</p>
        </div>
      </div>

      {/* Selection Panel */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Select Class *
            </label>
            <select
              value={selectedClass}
              onChange={(e) => setSelectedClass(e.target.value)}
              className="input-field"
              disabled={loading}
            >
              <option value="">Choose a class</option>
              {myClasses.map((cls) => (
                <option key={cls.class_id} value={cls.class_id}>
                  {cls.class_name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Academic Session *
            </label>
            <select
              value={selectedSession}
              onChange={(e) => {
                setSelectedSession(e.target.value);
                setSelectedTerm('');
              }}
              className="input-field"
              disabled={loading}
            >
              <option value="">Select Session</option>
              {academicSessions.map((session) => (
                <option key={session.id} value={session.id}>
                  {session.academic_session}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Term *
            </label>
            <select
              value={selectedTerm}
              onChange={(e) => setSelectedTerm(e.target.value)}
              className="input-field"
              disabled={!selectedSession || loading}
            >
              <option value="">Select Term</option>
              {terms.map((term) => (
                <option key={term.id} value={term.id}>
                  {term.term}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-end">
            <button
              onClick={fetchPerformanceData}
              disabled={!selectedClass || !selectedSession || !selectedTerm || loading}
              className="w-full btn-primary py-2"
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>
                  Loading...
                </>
              ) : (
                <>
                  <i className="fas fa-sync mr-2"></i>
                  Load Data
                </>
              )}
            </button>
          </div>
        </div>

        {selectedClass && selectedSession && selectedTerm && (
          <div className="mt-4 p-4 bg-primary-50 border border-primary-200 rounded-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-primary-700">
                  Analyzing <strong>{getCurrentClass()?.class_name}</strong>
                  <span> for <strong>{getCurrentSession()?.academic_session} - {getCurrentTerm()?.term}</strong></span>
                </p>
              </div>
              <div className="text-sm text-primary-600">
                {performanceData?.total_students || '--'} students
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Report Type Selector */}
      {/* <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Report Type</h3>
        <div className="flex space-x-2">
          {['summary', 'detailed', 'analytics', 'comparative'].map((type) => (
            <button
              key={type}
              onClick={() => setReportType(type)}
              className={`px-4 py-2 rounded-lg capitalize ${
                reportType === type
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {type} Report
            </button>
          ))}
        </div>
      </div> */}

      {/* Performance Overview */}
      {performanceData && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Key Metrics */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">Performance Overview</h3>


            {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="border rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-gray-900">{performanceData.class_average?.toFixed(1) || '--'}</div>
                <div className="text-sm text-gray-500">Class Average</div>
              </div>
              <div className="border rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-gray-900">
                  {performanceData.highest_average?.toFixed(1) || '--'}
                </div>
                <div className="text-sm text-gray-500">Highest Score</div>
              </div>
              <div className="border rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-gray-900">
                  {performanceData.lowest_average?.toFixed(1) || '--'}
                </div>
                <div className="text-sm text-gray-500">Lowest Score</div>
              </div>
              <div className="border rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-gray-900">
                  {performanceData.average_total_score?.toFixed(1) || '--'}
                </div>
                <div className="text-sm text-gray-500">Avg Total Score</div>
              </div>
            </div> */}

<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
  <div className="border rounded-lg p-4 text-center">
    <div className="text-2xl font-bold text-green-600">
      {performanceData?.statistics?.highest_average?.toFixed(1) || '0.0'}
    </div>
    <div className="text-sm text-gray-500">Highest Score</div>
    <div className="text-xs text-gray-400 mt-1">
      Total: {performanceData?.statistics?.highest_total_score?.toFixed(1) || '0.0'}
    </div>
  </div>
  <div className="border rounded-lg p-4 text-center">
    <div className="text-2xl font-bold text-blue-600">
      {performanceData?.statistics?.class_average || '0.0'}
    </div>
    <div className="text-sm text-gray-500">Class Average</div>
    <div className="text-xs text-gray-400 mt-1">
      {performanceData?.statistics?.total_students || 0} students
    </div>
  </div>
  <div className="border rounded-lg p-4 text-center">
    <div className="text-2xl font-bold text-yellow-600">
      {performanceData?.statistics?.lowest_average?.toFixed(1) || '0.0'}
    </div>
    <div className="text-sm text-gray-500">Lowest Score</div>
    <div className="text-xs text-gray-400 mt-1">
      Total: {performanceData?.statistics?.lowest_total_score?.toFixed(1) || '0.0'}
    </div>
  </div>
  <div className="border rounded-lg p-4 text-center">
    <div className="text-2xl font-bold text-purple-600">
      {performanceData?.statistics?.standard_deviation || '0.0'}
    </div>
    <div className="text-sm text-gray-500">Standard Deviation</div>
    <div className="text-xs text-gray-400 mt-1">
      Score spread indicator
    </div>
  </div>
</div>
{/*  */}
            {/* Subject Performance */}
            <div className="mt-6">
              <h4 className="font-medium text-gray-700 mb-3">Subject Performance</h4>
              <div className="h-64">
                <ChartComponent
                  type="bar"
                  data={getSubjectPerformanceChartData()}
                  options={{
                    scales: {
                      y: {
                        min: 0,
                        max: 100,
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* Top Students */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">Top 5 Students</h3>
              <span className="text-sm text-gray-500">Based on total score</span>
            </div>
            <div className="space-y-4">
              {performanceData.top_students?.slice(0, 5).map((student, index) => (
                <div key={index} className="border rounded-lg p-4 hover:bg-gray-50">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="font-medium text-gray-900">
                        #{index + 1} - {student.student_reg}
                      </div>
                      <div className="text-sm text-gray-500">Position: {student.position}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-lg font-bold text-green-600">{student.total_score}</div>
                      <div className="text-sm text-gray-500">Avg: {student.average}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Detailed Reports */}
      {performanceData && (
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-lg font-semibold text-gray-800">Detailed Analysis</h3>
            {/* <div className="flex space-x-2">
              <button
                onClick={() => handleGenerateReport('pdf')}
                disabled={generatingReport}
                className="btn-primary px-4 py-2 flex items-center"
              >
                {generatingReport ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Generating...
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-pdf mr-2"></i>
                    Export PDF
                  </>
                )}
              </button>
              <button
                onClick={() => handleGenerateReport('excel')}
                disabled={generatingReport}
                className="btn-secondary px-4 py-2 flex items-center"
              >
                <i className="fas fa-file-excel mr-2"></i>
                Export Excel
              </button>
            </div> */}


<div className="flex space-x-2">
  {/* <button
    onClick={() => handleGenerateReport('pdf')}
    disabled={generatingReport}
    className="btn-primary px-4 py-2 flex items-center"
  >
    {generatingReport ? (
      <>
        <i className="fas fa-spinner fa-spin mr-2"></i>
        Generating PDF...
      </>
    ) : (
      <>
        <i className="fas fa-file-pdf mr-2"></i>
        Export PDF
      </>
    )}
  </button> */}
  <button
    onClick={() => handleGenerateReport('excel')}
    disabled={generatingReport}
    className="btn-secondary px-4 py-2 flex items-center"
  >
    <i className="fas fa-file-excel mr-2"></i>
    Export Excel
  </button>
</div>
            {/*  */}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Grade Distribution */}
            <div>
              <h4 className="font-medium text-gray-700 mb-3">Grade Distribution</h4>
              <div className="h-64">
                <ChartComponent
                  type="doughnut"
                  data={getGradeDistributionData()}
                />
              </div>
            </div>

            {/* Performance Trend */}
            <div>
              <h4 className="font-medium text-gray-700 mb-3">Performance Trend</h4>
              <div className="h-64">
                <ChartComponent
                  type="line"
                  data={getPerformanceTrendData()}
                  options={{
                    scales: {
                      y: {
                        min: 0,
                        max: 100,
                      }
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* Subject-wise Analysis */}
          {performanceData.subject_performance && (
            <div className="mt-6">
              <h4 className="font-medium text-gray-700 mb-3">Subject-wise Performance</h4>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                        Subject
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                        Average Score
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                        Highest Score
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                        Lowest Score
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                        Students Count
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {Object.entries(performanceData.subject_performance).map(([subject, data]) => (
                      <tr key={subject} className="hover:bg-gray-50">
                        <td className="px-6 py-4 text-sm font-medium text-gray-900">
                          {subject}
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center">
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className="bg-green-600 h-2 rounded-full"
                                style={{ width: `${data.average}%` }}
                              ></div>
                            </div>
                            <span className="ml-2 text-sm text-gray-900">{data.average.toFixed(1)}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {data.highest?.toFixed(1) || '--'}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {data.lowest?.toFixed(1) || '--'}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {data.students_count}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}


 

    
      {/* Empty State */}
      {!performanceData && selectedClass && selectedSession && selectedTerm && (
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <i className="fas fa-chart-bar text-4xl text-gray-300 mb-4"></i>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Performance Data</h3>
          <p className="text-gray-500 max-w-md mx-auto">
            No performance data found for the selected class, session, and term combination.
          </p>
          <p className="text-sm text-gray-400 mt-1">
            Make sure grades have been calculated for this term.
          </p>
        </div>
      )}

      {!selectedClass || !selectedSession || !selectedTerm ? (
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <i className="fas fa-chart-line text-4xl text-gray-300 mb-4"></i>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Select Parameters</h3>
          <p className="text-gray-500 max-w-md mx-auto">
            Please select a class, academic session, and term to generate reports.
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default ClassReports;